import { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { buildParseRequest, successMessage } from "./smartUploadModel";

export const useSmartUpload = ({ userId, instanceId, applyToInstance, onComplete, onClose }) => {
  const [mode, setModeState] = useState("file");
  const [parseType, setParseType] = useState("auto");
  const [file, setFileState] = useState(null);
  const [pastedText, setPastedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const setMode = (m) => { setModeState(m); setResult(null); };
  const setFile = (f) => { setFileState(f); setResult(null); };
  const canParse = !loading && (mode === "file" ? !!file : !!pastedText.trim());

  const handleParse = async () => {
    if (mode === "file" && !file) { toast.error("Please select a file first"); return; }
    if (mode === "paste" && !pastedText.trim()) { toast.error("Please enter some text to parse"); return; }
    setLoading(true);
    setResult(null);
    try {
      const { url, form } = buildParseRequest({ mode, file, pastedText, parseType, userId, instanceId, applyToInstance });
      const { data } = await axios.post(`${API}${url}`, form);
      setResult(data);
      if (data.success) {
        toast.success(successMessage(data));
        onComplete?.(data);
      } else {
        toast.error(data.error || "Parsing failed");
      }
    } catch (error) {
      console.error("Parse error:", error);
      toast.error(error.response?.data?.detail || "Failed to parse document");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFileState(null); setPastedText(""); setResult(null); setParseType("auto");
    onClose();
  };

  return { mode, setMode, parseType, setParseType, file, setFile, pastedText, setPastedText, loading, result, canParse, handleParse, handleClose };
};
